import { useSelector } from "react-redux"
import { selectTenantName } from "store/slices/tenantSlice"
import useTenant from "./useTenant"

const useTenantDisplayName = () => {
  const { tenantName: contextTenantName } = useTenant()
  const reduxTenantName = useSelector(selectTenantName)
  const authTenantName = useSelector(
    state => state.Login?.authUser?.tenant?.name || null
  )

  return contextTenantName || reduxTenantName || authTenantName || ""
}

export default useTenantDisplayName
